import classNames from 'classnames';
import PropType from 'prop-types';
import React from 'react';
import injectSheet from 'react-jss';

import styles from './button.style';

export class Button extends React.PureComponent {
  static propTypes = {
    classes: PropType.object.isRequired,
    onClick: PropType.func.isRequired,
    children: PropType.node.isRequired,
    top: PropType.bool,
    right: PropType.bool,
    className: PropType.string
  };

  static defaultProps = {
    top: false,
    right: false,
    className: ''
  };

  render() {
    const { classes, onClick, children, top, right, className, ...props } =
      this.props;

    return (
      <button
        className={classNames(classes.root, classes.rootDynamic, className)}
        onClick={onClick}
        {...props}
      >
        {children}
      </button>
    );
  }
}

export default injectSheet(styles)(Button);
